<template>
  <div id="course_list">
    <div class="bottombox">
      <Header ref="header" />
      
    </div>
    <!-- bottombox end -->
    <div class="banner">
      <el-carousel arrow="never" indicator-position="none" loop height="452px">
        <el-carousel-item>
          <img
            src="../../assets/publicClass/banner.png"
            width="1920"
            height="452"
          />
        </el-carousel-item>
        <el-carousel-item>
          <img
            src="../../assets/publicClass/banner2.png"
            width="1920"
            height="452"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- banner end -->
    <div class="screen">
      <div class="clearfix screen_1">
        <strong>· SEARCH</strong>
      </div>
    </div>
    <!-- screen end -->
    <div class="main">
      <div class="main_list">
        <ul class="clearfix">
          <li v-for="(item, index) in listBox">
            <router-link
              :to="{ path: '/course_details', query: { Id: item.Id } }"
            >
              <!-- <a href="/course_details/?details=1"> -->
              <dl>
                <dt><img :src="item.CoverImg" /></dt>
                <dd>
                  <h2>{{ item.Title }}</h2>
                  <p class="p0">
                    <span>{{ item.ApplyStudentType }}</span>
                  </p>
                  <p class="p1">{{ item.SynopsisText }}</p>
                  <div class="p3">
                    <strong>￥{{ item.Price }}</strong>
                  </div>
                </dd>
              </dl>
              <!-- </a> -->
            </router-link>
          </li>
        </ul>
      </div>
      <!-- main_list end -->
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="12"
          :total="total"
          background
          layout="total,prev, pager, next, jumper,->"
        >
        </el-pagination>
      </div>
      <!-- block end -->
    </div>
    <!-- main end -->
  </div>
</template>

<script>
import detailsBox from "../publicClass/publicClass_list.vue";
import Header from "../../components/header/Header.vue"; //公共头部

export default {
  name: "App",
  components: {
    // 将组件隐射为标签,登陆弹窗
    Header,
    
  },
  data() {
    return {
      tokenkey: "",
      currentPage: 1,
      listBox: "", //列表盒子
      total: 0 //总条数
    };
  },
  methods: {
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      let that = this;
      // console.log(`当前页: ${val}`);
      this.currentPage = val;
      that.getDataListFu(that.currentPage, this.$route.query.keyword);
    },
    getDataListFu(currentPage, keyword) {
      let that = this;
      if (keyword) {
        this.$api.get(
          "https://schoolapi.eiceducation.com.cn/api/Search?page=" +
            currentPage +
            "&limit=12&keyword=" +
            keyword,
          "",
          res => {
            if (res.data.code == 200) {
              // console.log(res)
              that.listBox = res.data.results;
              that.total = res.data.count;
            }
          }
        );
      } else {
        this.$api.get(
          "https://schoolapi.eiceducation.com.cn/api/Search?page=" +
            currentPage +
            "&limit=12",
          "",
          res => {
            if (res.data.code == 200) {
              // console.log(res)
              that.listBox = res.data.results;
              that.total = res.data.count;
            }
          }
        );
      }
    }
  },
  mounted: function() {
    //自动触发写入的函数
    let that = this;
    // if (!this.$cookies.isKey("token")) {
    //   this.$router.push("/index")
    // }
    this.getDataListFu(this.currentPage, this.$route.query.keyword);
    that.tokenkey = that.$cookies.get("token");
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bottombox {
  box-shadow: 0px 3px 5px 0px rgba(233, 233, 233, 0.5);
  position: relative;
  z-index: 9;
}

.header_left {
  background: #f00;
}

.banner {
  width: 100%;
  height: 452px;
  position: relative;
  overflow: hidden;
}

.banner img {
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -960px;
}

.screen {
  background: #fff;
}

.screen_1 {
  width: 1180px;
  height: 66px;
  border-bottom: 1px #d5d5d5 solid;
  padding-top: 32px;
  box-sizing: border-box;
  margin: 0 auto;
  margin-bottom: 20px;
}

.screen_1 strong {
  display: block;
  font-size: 16px;
  color: #d5d5d5;
  line-height: 20px;
  float: left;
  font-weight: normal;
}

.main {
  width: 100%;
  background: #fafafa;
  padding-top: 24px;
  padding-bottom: 78px;
}

.main_list {
  width: 1180px;
  margin: 0 auto;
}

.main_list ul {
  padding-bottom: 60px;
}

.main_list ul li {
  width: 280px;
  height: 346px;
  float: left;
  background: #ffffff;
  box-shadow: 0px 0px 10px 6px rgba(245, 246, 246, 0.2);
  border-radius: 8px;
  overflow: hidden;
  margin-right: 20px;
  margin-bottom: 20px;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
  position: relative;
}

.main_list ul li:hover {
  box-shadow: 0px 0px 10px 6px #f5f6f6;
  transform: translateY(-4px);
}

.main_list ul li:nth-child(4n) {
  margin-right: 0;
}

.main_list ul li dt {
  width: 280px;
  height: 174px;
  overflow: hidden;
}

.main_list ul li dt img {
  width: 100%;
}

.main_list ul li dd {
  padding: 0 16px;
  padding-top: 20px;
  text-align: left;
}

.main_list ul li dd h2 {
  font-size: 16px;
  color: #333;
  line-height: 16px;
  margin-bottom: 8px;
  font-weight: normal;
}

.main_list ul li dd .p0 {
  height: 20px;
  margin-bottom: 8px;
}

.main_list ul li dd .p0 span {
  display: inline-block;
  max-width: 245px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 12px;
  color: #666;
  background: #f5f6f6;
  border-radius: 10px;
  padding: 0 10px;
  box-sizing: border-box;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.main_list ul li dd .p1 {
  width: 100%;
  font-size: 12px;
  color: #4e5cf6;
  line-height: 12px;
  margin-bottom: 22px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.main_list ul li dd .p3 {
  height: 38px;
}

.main_list ul li dd .p3 strong {
  font-size: 24px;
  float: right;
  line-height: 38px;
  color: #333;
}

.main_list ul li dd .p4 {
  font-size: 12px;
  color: #666666;
  position: absolute;
  bottom: 17px;
  right: 16px;
}

.block {
  width: 1180px;
  margin: 0 auto;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/page2/courseList/course_search.vue